import {Badge, makeStyles} from '@material-ui/core';
import NotificationsOutlined from '@material-ui/icons/NotificationsOutlined';
import {DataLayer, useEffectUpdate} from '@nimbus-target/ui';
import sound from 'assets/sound.mp3';
import IconButton from 'components/buttons/IconButton';
import Drawer from 'components/drawer/Drawer';
import {useSocketContext} from 'context';
import {Fragment, useCallback, useEffect, useState} from 'react';
import {useAppValue, useDispatchSetAppValue} from 'redux/hooks/app';
import {useDispatchPost} from 'redux/hooks/fetch';
import useSound from 'use-sound';
import AlertsHeader from './Alerts.Header';
import AlertsMessages from './Alerts.Messages';

function gtag(...rest) {
	DataLayer.push(...rest.slice(1));
}

const useStyles = makeStyles(theme => ({
	icon: {
		fontSize: 28,
		[theme.breakpoints.down('1300')]: {
			fontSize: 22,
		},
		[theme.breakpoints.down('1100')]: {
			fontSize: 20,
		},
	},
}));

function AlertsButton() {
	const styles = useStyles();
	const {socketCore} = useSocketContext();
	const post = useDispatchPost();
	const [play] = useSound(sound);
	const countNotificationsNimbus = useAppValue('countNotificationsNimbus');
	const setCountNotificationsNimbus = useDispatchSetAppValue('countNotificationsNimbus');
	const setCountNotificationsNotAccept = useDispatchSetAppValue('countNotificationsNotAccept');
	const drawerNotifications = useAppValue('notificationsDrawer');
	const setDrawerNotifications = useDispatchSetAppValue('notificationsDrawer');
	const [isSwitchChecked, setSwitchChecked] = useState(false);
	const status = isSwitchChecked ? 'read' : 'unread';
	const [reloadKey, setReloadKey] = useState(0);

	const handleReloadNotifications = () => {
		setReloadKey(reloadKey + 1);
	};

	const clearAllNotifications = () => {
		post('/notification-center/clear-all', {channel: 'nimbus'}).then(() => {
			getNotification();
			handleReloadNotifications();
		});
	};

	const getNotification = useCallback(() => {
		post('/notification-center/count', {channel: 'nimbus', status}).then(responseData => {
			setCountNotificationsNimbus(responseData.data);
			setCountNotificationsNotAccept(responseData.countNotAccepted);
		});
	}, [post, status, setCountNotificationsNimbus, setCountNotificationsNotAccept]);

	useEffect(() => {
		if (!socketCore) return undefined;
		const handleNotification = _data => {
			getNotification();
			play();
		};
		socketCore.on('notification', handleNotification);
		return () => {
			socketCore.removeListener('notification');
		};
	}, [getNotification, play, socketCore]);

	useEffect(() => {
		getNotification();
	}, [getNotification]);

	useEffectUpdate(() => {
		gtag('event', 'header_alerts_clicked', {
			opened: drawerNotifications,
		});
	}, [drawerNotifications]);

	return (
		<Fragment>
			<IconButton
				handleClick={() => setDrawerNotifications(true)}
				data-tour='tour_home_menu_notificaoes'
				alt='Mensagens'
			>
				<Badge
					badgeContent=' '
					max={9}
					variant='dot'
					overlap='circular'
					color='error'
					invisible={!countNotificationsNimbus}
				>
					<NotificationsOutlined className={styles.icon} />
				</Badge>
			</IconButton>
			<Drawer
				direction={'right'}
				isOpen={drawerNotifications}
				onClose={() => setDrawerNotifications(false)}
				header={
					<AlertsHeader
						nimbusLength={countNotificationsNimbus}
						isSwitchChecked={isSwitchChecked}
						setSwitchChecked={setSwitchChecked}
						setDrawerNotifications={setDrawerNotifications}
						clearAllNotifications={clearAllNotifications}
					/>
				}
			>
				<AlertsMessages key={reloadKey} type='nimbus' status={status} />
			</Drawer>
		</Fragment>
	);
}

AlertsButton.displayName = 'Alerts.Button';
export default AlertsButton;
